import { datadogRum, RumInitConfiguration } from "@datadog/browser-rum";

import packageInfo from "../../package.json";
import { getAppConfigSetting } from "./getAppConfigSetting";

const datadogConfig: RumInitConfiguration = {
  version: packageInfo.version,
  ...getAppConfigSetting("datadog"),
};

export const startRum = () => {
  datadogRum.init(datadogConfig);
};
